import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TarifaRepository } from '../../../domain/repositories/tarifa/tarifa.repository';
import {
  PlanesConTarifas,
  TarifaBaseParams,
} from '../../../domain/interfaces/tarifa/tarifa.interface';
import { TarifaService } from '../../services/tarifa/tarifa.service';

@Injectable({ providedIn: 'root' })
export class TarifaRepositoryImplementation extends TarifaRepository {
  private readonly tarifaService = inject(TarifaService);

  consultarTarifasPlanes(params: TarifaBaseParams): Observable<PlanesConTarifas> {
    return this.tarifaService.consultarTarifasPlanes(params);
  }
}
